import {
    CompanyAccountModelDto,
    InternalTransferAddTransactionModelDto,
} from '@treasury/api/channel';
import { TmHttpClient } from '@treasury/core/http';

export const getTransferAccounts = async (type: string) =>
    (await TmHttpClient.getInstance()).request<CompanyAccountModelDto[]>(
        `companyaccounts/GetForProductFeature?productFeatureType=InternalTransfer&reportType=create&type=${type}`,
        {
            method: 'GET',
        }
    );

export const getTransferTemplateAccounts = async (type: string) =>
    (await TmHttpClient.getInstance()).request<CompanyAccountModelDto[]>(
        `companyaccounts/GetForProductFeature?productFeatureType=
InternalTransferTemplate&reportType=create&type=${type}`,
        {
            method: 'GET',
        }
    );

export const getFilteredTransferAccounts = async (
    oppositeAccountId: number,
    type: string,
    isTemplate = false
) => {
    const productFeatureType = isTemplate ? 'InternalTransferTemplate' : 'InternalTransfer';
    return (await TmHttpClient.getInstance()).request<CompanyAccountModelDto[]>(
        `companyaccounts/GetForProductFeature?isForLoanPayment=false&oppositeAccountId=${oppositeAccountId}&productFeatureType=${productFeatureType}&reportType=create&type=${type}`,
        {
            method: 'GET',
        }
    );
};

export const getTransferFromAccounts = async () =>
    (await TmHttpClient.getInstance()).request<CompanyAccountModelDto[]>(
        `companyaccounts/GetForProductFeature?productFeatureType=InternalTransfer&reportType=create&type=From`,
        {
            method: 'GET',
        }
    );

export const getTransferFilterFromAccounts = async () =>
    (await TmHttpClient.getInstance()).request<CompanyAccountModelDto[]>(
        `companyaccounts/GetWithProductFeature?type=From&productfeaturetype=InternalTransfer`,
        {
            method: 'GET',
        }
    );

export const getTransferFilterToAccounts = async () =>
    (await TmHttpClient.getInstance()).request<CompanyAccountModelDto[]>(
        `companyaccounts/GetWithProductFeature?type=To&productfeaturetype=InternalTransfer`,
        {
            method: 'GET',
        }
    );

export const getTransferToAccounts = async (oppositeAccountId: number) =>
    (await TmHttpClient.getInstance()).request<CompanyAccountModelDto[]>(
        `companyaccounts/GetForProductFeature?isForLoanPayment=false&oppositeAccountId=${oppositeAccountId}&productFeatureType=InternalTransfer&reportType=create&type=To`,
        {
            method: 'GET',
        }
    );

export const createTransfer = async (transfer: InternalTransferAddTransactionModelDto) =>
    (await TmHttpClient.getInstance()).request<InternalTransferAddTransactionModelDto>(
        `internalTransfers/?type=add`,
        {
            method: 'POST',
            body: transfer,
        }
    );
